export default {
    methods: {
        canBeStarted(obj) {
            return (obj.state === '1' || obj.state === '2');
        },
        canBeStopped(obj) {
            return obj.state === '3';
        },
        canBeEdited(obj) {
            return obj.state === '1';
        },
        isRunning(obj) {
            return obj.state === '3';
        },
        isPreview(obj) {
            return obj.state === '2';
        },
        isAborted(obj) {
            return obj.state === '6';
        },
        isParked(obj) {
            return obj.state === '7';
        },
        isPriceTurboInitiated(obj) {
            if (!obj.states) {
                return false;
            }
            return (Object.values(obj.states).indexOf('PRICETURBO_INITIATED') >= 0);
        },
        isPriceTurboActive(obj) {
            if (!obj.states) {
                return false;
            }
            return (Object.values(obj.states).indexOf('PRICETURBO_ACTIVE') >= 0);
        },
        isInstantDiscountGranted(obj) {
            if (!obj.states) {
                return false;
            }
            return (Object.values(obj.states).indexOf('INSTANT_DISCOUNT') >= 0);
        },
        getAuctionState(obj) {
            switch (obj.state) {
                case "0":
                    return {'text': this._i18n.t('shared.auction_status.planning'), 'type': 'yellow'}
                case "1":
                    return {'text': this._i18n.t('shared.auction_status.planned'), 'type': 'orange'};
                case "2":
                    return {'text': this._i18n.t('shared.auction_status.preview'), 'type': 'green'};
                case "3":
                    return {'text': this._i18n.t('shared.auction_status.running'), 'type': 'green'};
                case "4":
                    return {'text': this._i18n.t('shared.auction_status.trailing'), 'type': 'green'};
                case "5":
                    return {'text': this._i18n.t('shared.auction_status.finished'), 'type': 'red'};
                case "6":
                    return {'text': this._i18n.t('shared.auction_status.cancelled'), 'type': 'red'}
                case "7":
                    return {'text': this._i18n.t('shared.auction_status.parked'), 'type': 'blue'}
            }
        },
        isAuctionEditable(auction) {
            return !auction.finished && !auction.running && auction.campaign_id;
        }
    },
};
